// // FilterSidebar.js
// import React, { useState } from "react";
// import {
//     FormGroup,
//     FormControlLabel,
//     Checkbox,
//     FormLabel,
//     FormControl,
//     Divider,
// } from "@mui/material";
// import './FilterSidebar.css';
// import { difficultyOptions, durationOptions, groupSizeOptions} from '../data/TravelOptions';
//
//
// const difficultyLabels = difficultyOptions.map(opt => opt.label.split('–')[0].trim());
// const sizeLabels = groupSizeOptions.map(opt => opt.label);
// const durationTripLabels = durationOptions.map(opt => opt.label);
// const genderOptions = ['נשים בלבד', 'גברים בלבד']; // stays local
//
//
// const FilterSidebar = ({ onFilterApply }) => {
//     // Store selected filters in component state
//     const [pendingFilters, setPendingFilters] = useState({
//         difficulty: [],
//         size: [],
//         gender: [],
//         duration: [],
//         accessible: false // Added "accessible" filter as a boolean
//     });
//
//     // Handle checkbox change for both multi-select and single "accessible"
//     const handleChange = (category, value) => {
//         setPendingFilters((prev) => {
//             let newFilters;
//
//             if (category === 'accessible') {
//                 // Toggle boolean for accessible checkbox
//                 newFilters = { ...prev, accessible: !prev.accessible };
//             } else {
//                 // Toggle values in array for other categories
//                 const current = prev[category];
//                 const updated = current.includes(value)
//                     ? current.filter((v) => v !== value)
//                     : [...current, value];
//                 newFilters = { ...prev, [category]: updated };
//             }
//
//             // Notify parent component with updated filters
//             if (onFilterApply) {
//                 onFilterApply(newFilters);
//             }
//
//             return newFilters;
//         });
//     };
//
//     // Render a group of checkboxes for a given category
//     const renderCheckboxGroup = (label, options, category) => (
//         <FormControl component="fieldset" sx={{ marginBottom: 2 }}>
//             <FormLabel component="legend">{label}</FormLabel>
//             <FormGroup>
//                 {options.map((option) => (
//                     <FormControlLabel
//                         key={option}
//                         control={
//                             <Checkbox
//                                 checked={pendingFilters[category].includes(option)}
//                                 onChange={() => handleChange(category, option)}
//                             />
//                         }
//                         label={option}
//                     />
//                 ))}
//             </FormGroup>
//             <Divider sx={{ marginTop: 1 }} />
//         </FormControl>
//     );
//
//     return (
//         <div className="filter-sidebar" dir="rtl">
//             <h2 style={{ marginBottom: "16px" }}>סינון</h2>
//
//             {/* Scrollable container for filter categories */}
//             <div className="filter-categories" style={{ overflowY: "auto", flexGrow: 1 }}>
//             {/*<div className="filter-categories">*/}
//             {renderCheckboxGroup("רמת קושי", difficultyLabels, "difficulty")}
//                 {renderCheckboxGroup("גודל הקבוצה", sizeLabels, "size")}
//                 {renderCheckboxGroup("משך הטיול", durationTripLabels, "duration")}
//                 {/* Gender checkbox without heading */}
//                 {/* <FormControl component="fieldset" sx={{ marginBottom: 0, marginTop: 0 }}>
//                     <FormGroup sx={{ marginTop: 0 }}>
//                         <FormControlLabel
//                             sx={{ mt: 0 }} // Remove top margin here
//                             control={
//                                 <Checkbox
//                                     checked={pendingFilters.gender.includes("אנשים רק מהמגדר שלי")}
//                                     onChange={() => handleChange("gender", "אנשים רק מהמגדר שלי")}
//                                 />
//                             }
//                             label="רק אנשים מהמגדר שלי"
//                         />
//                     </FormGroup>
//                     <Divider sx={{ marginTop: 1 }} />
//                 </FormControl> */}
//
//                 {/* Accessible checkbox */}
//                 {/* <FormControl component="fieldset" sx={{ marginBottom: 0, marginTop: 0 }}>
//                     <FormGroup sx={{ marginTop: 1 }}>
//                         <FormControlLabel
//                             sx={{ mt: 0 }} // Remove top margin here too
//                             control={
//                                 <Checkbox
//                                     checked={pendingFilters.accessible}
//                                     onChange={() => handleChange("accessible")}
//                                 />
//                             }
//                             label="מסלול נגיש ♿" */}
//                         {/* />
//                     </FormGroup>
//                     <Divider sx={{ marginTop: 1 }} />
//                 </FormControl> */}
//
//             </div>
//         </div>
//     );
// };
//
// export default FilterSidebar;
//


// FilterSidebar.js
import React, { useState } from "react";
import {
    FormGroup,
    FormControlLabel,
    Checkbox,
    FormLabel,
    FormControl,
    Divider,
} from "@mui/material";
import './FilterSidebar.css';
import { difficultyOptions, durationOptions, groupSizeOptions} from '../data/TravelOptions';


const difficultyLabels = difficultyOptions.map(opt => opt.label.split('–')[0].trim());
const sizeOptions = groupSizeOptions.map(opt => ({
    value: opt.value,
    label: opt.label
}));

const durationTripLabels = durationOptions.map(opt => opt.label);
const genderOptions = ['נשים בלבד', 'גברים בלבד']; // stays local


const FilterSidebar = ({ onFilterApply }) => {
    // Store selected filters in component state
    const [pendingFilters, setPendingFilters] = useState({
        difficulty: [],
        size: [],
        gender: [],
        duration: [],
        accessible: false // Added "accessible" filter as a boolean
    });

    // Handle checkbox change for both multi-select and single "accessible"
    const handleChange = (category, value) => {
        setPendingFilters((prev) => {
            let newFilters;

            if (category === 'accessible') {
                // Toggle boolean for accessible checkbox
                newFilters = { ...prev, accessible: !prev.accessible };
            } else {
                // Toggle values in array for other categories
                const current = prev[category];
                const updated = current.includes(value)
                    ? current.filter((v) => v !== value)
                    : [...current, value];
                newFilters = { ...prev, [category]: updated };
            }

            // Notify parent component with updated filters
            if (onFilterApply) {
                onFilterApply(newFilters);
            }

            return newFilters;
        });
    };

    // Render a group of checkboxes for a given category
    const renderCheckboxGroup = (label, options, category) => (
        <FormControl component="fieldset" sx={{ marginBottom: 2 }}>
            <FormLabel component="legend">{label}</FormLabel>
            <FormGroup>
                {options.map((option) => {
                    const value = option.value || option;  // תומך גם באופציות פשוטות (string)
                    const labelText = option.label || option;
                    return (
                        <FormControlLabel
                            key={value}
                            control={
                                <Checkbox
                                    checked={pendingFilters[category].includes(value)}
                                    onChange={() => handleChange(category, value)}
                                />
                            }
                            label={labelText}
                        />
                    );
                })}
            </FormGroup>
            <Divider sx={{ marginTop: 1 }} />
        </FormControl>
    );


    return (
        <div className="filter-sidebar" dir="rtl">
            <h2 style={{ marginBottom: "16px" }}>סינון</h2>

            {/* Scrollable container for filter categories */}
            <div className="filter-categories" style={{ overflowY: "auto", flexGrow: 1 }}>
                {/*<div className="filter-categories">*/}
                {renderCheckboxGroup("רמת קושי", difficultyLabels, "difficulty")}
                {renderCheckboxGroup("גודל הקבוצה", sizeOptions, "size")}
                {renderCheckboxGroup("משך הטיול", durationTripLabels, "duration")}
                {/* Gender checkbox without heading */}
                {/* <FormControl component="fieldset" sx={{ marginBottom: 0, marginTop: 0 }}>
                    <FormGroup sx={{ marginTop: 0 }}>
                        <FormControlLabel
                            sx={{ mt: 0 }} // Remove top margin here
                            control={
                                <Checkbox
                                    checked={pendingFilters.gender.includes("אנשים רק מהמגדר שלי")}
                                    onChange={() => handleChange("gender", "אנשים רק מהמגדר שלי")}
                                />
                            }
                            label="רק אנשים מהמגדר שלי"
                        />
                    </FormGroup>
                    <Divider sx={{ marginTop: 1 }} />
                </FormControl> */}

                {/* Accessible checkbox */}
                {/* <FormControl component="fieldset" sx={{ marginBottom: 0, marginTop: 0 }}>
                    <FormGroup sx={{ marginTop: 1 }}>
                        <FormControlLabel
                            sx={{ mt: 0 }} // Remove top margin here too
                            control={
                                <Checkbox
                                    checked={pendingFilters.accessible}
                                    onChange={() => handleChange("accessible")}
                                />
                            }
                            label="מסלול נגיש ♿" */}
                {/* />
                    </FormGroup>
                    <Divider sx={{ marginTop: 1 }} />
                </FormControl> */}

            </div>
        </div>
    );
};

export default FilterSidebar;

